export const query_checkAricDektopLicense = `
query checkAricDesktopEnabled($pIva:String!){
    checkAricDesktopLicense(partitaIva:$pIva){
        isDesktopEnabled
    }
}`;